import { createStyles } from "@mantine/core";

/**
 * What is left of the provider Documents styling after the tab moved onto the
 * Documents module drive: the listing's own styling now lives in
 * components/DocumentsDrive/style.js, so only the modals are dressed here.
 */
const useStyles = createStyles(() => ({
  wrapper: {
    width: "100%",
  },
  folderModal: {
    "& .mantine-Modal-body": {
      backgroundColor: "#F5F5F5",
    },
  },
  folderModalBody: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: 10,
    padding: 20,
    marginTop: 10,
    marginBottom: 20,
    border: "1px solid #E5E5EA",
  },
  previewModal: {
    "& .mantine-Modal-body": {
      overflow: "auto",
      maxHeight: "78vh",
    },
    "& .mantine-Paper-root": {
      overflow: "initial",
    },
  },
}));

export default useStyles;
